
const digest = 'b8afb5a1502b81db41257ea91cf14eaebafffb5379ddbbb7ac037f3cf8ece4c2';
const classes = {"wrapper":"_wrapper_x9s3c_1","button":"_button_x9s3c_5","active":"_active_x9s3c_12","title":"_title_x9s3c_22","menu":"_menu_x9s3c_27","hidden":"_hidden_x9s3c_37"};
const css = `._wrapper_x9s3c_1 {
  position: relative;
}

._button_x9s3c_5 {
  color: #1665d8;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 12px 0;
}
._button_x9s3c_5._active_x9s3c_12 {
  color: #1553aa;
  background-color: #dce7f9;
  border-radius: 5px;
  text-decoration: none;
  padding: 5px 10px;
  margin: 7px 0;
  height: fit-content;
}

._title_x9s3c_22 {
  display: inline-block;
  text-decoration: underline;
}

._menu_x9s3c_27 {
  position: absolute;
  z-index: 5;
  padding: 5px 14px 14px;
  background-color: #ffffff;
  border: 1px solid #eaedf3;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.1);
}
._menu_x9s3c_27._hidden_x9s3c_37 {
  display: none;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  